import { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/ImageSlider.css';

export default function ImageSlider({ images, onImageClick }) {
	const [currentIndex, setCurrentIndex] = useState(0);
	const sliderRef = useRef(null);

	// Number of thumbnails to show at once
	const thumbnailsToShow = 4;
	const thumbnailWidth = 138;

	const canGoLeft = currentIndex > 0;
	const canGoRight = currentIndex < images.length - thumbnailsToShow;

	const goLeft = () => {
		if (canGoLeft) {
			setCurrentIndex((prev) => prev - 1);
		}
	};

	const goRight = () => {
		if (canGoRight) {
			setCurrentIndex((prev) => prev + 1);
		}
	};

	const translateX = -currentIndex * thumbnailWidth;

	return (
		<div className="image-slider-container">
			<button
				className="slider-nav-button prev"
				onClick={goLeft}
				disabled={!canGoLeft}
				aria-label="Previous images"
			>
				<ChevronLeft size={16} />
			</button>

			<div
				className="image-slider-wrapper"
				ref={sliderRef}
				style={{ transform: `translateX(${translateX}px)` }}
			>
				{images.map((img, i) => (
					<img
						className="slider-thumbnail"
						alt={`Thumbnail ${i + 1}`}
						src={img}
						key={img}
						onClick={() => onImageClick(i)}
					/>
				))}
			</div>

			<button
				className="slider-nav-button next"
				onClick={goRight}
				disabled={!canGoRight}
				aria-label="Next images"
			>
				<ChevronRight size={16} />
			</button>
		</div>
	);
}
